module.exports = __webpack_public_path__ + "static/media/devflix.a382e667.svg";